import { createSlice } from '@reduxjs/toolkit';
import mapImage1 from '../images/Driftsbyen.png';
//import mapImage2 from '../images/no_map.png';

export const reducerName = 'staticMapState';

const STATIC_MAP_SET_ACTIVE = 'STATIC_MAP_SET_ACTIVE';
const STATIC_MAP_SET_INITIAL_STATE = 'STATIC_MAP_SET_INITIAL_STATE';

const staticMaps = [
    {
        id: 1,
        name: "Kort",
        map: mapImage1
    },
    /*
    {
        id: 2,
        name: "Skærmkort",
        map: mapImage2
    }
    */
];

const initialState = {
    staticMaps: staticMaps,
    activeStaticMap: null
};

const staticMapSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setInitialState: (state) => {
            if (state.activeStaticMap === null && state.staticMaps.length > 0) {
                state.activeStaticMap = state.staticMaps[0];
            }
        },
        setActive: (state, action) => {
            state.activeStaticMap = action.payload;
        }
    }
});

export const {
    setInitialState,
    setActive,
} = staticMapSlice.actions;

export default staticMapSlice.reducer;

export const reducer = staticMapSlice.reducer;

export const setInitialStateThunk = () => (dispatch, getState) => {
    const state = getState().staticMapState;
    if (state.activeStaticMap === null && state.staticMaps.length > 0) {
        dispatch(setInitialState());
    }
};

export const actionCreators = {
    setInitialState: setInitialStateThunk,
    setActive: (staticMap) => (dispatch) => {
        dispatch(setActive(staticMap));
    }
};